import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

interface LogoProps {
  className?: string;
  /** Hide the wordmark, showing only the icon. */
  iconOnly?: boolean;
}

export function Logo({ className, iconOnly }: LogoProps) {
  return (
    <Link
      to="/"
      className={cn("inline-flex items-center gap-2 group", className)}
      aria-label="BCH Launch home"
    >
      <img
        src="/logo.png"
        alt=""
        className="h-9 w-9 object-contain transition-transform group-hover:scale-105 motion-reduce:transform-none"
      />
      {!iconOnly && (
        <span className="text-xl font-bold tracking-tight">
          BCH <span className="text-primary">Launch</span>
        </span>
      )}
    </Link>
  );
}
